import { useState } from 'react';
import classNames from 'classnames';
import { EQActionType } from '..';
import { useOutsideClick } from 'src/Hooks';
import { ReactComponent as ExpandIcon } from '../Assets/expand.svg';
import { Hint } from '@redoc/ui-kit';
import './EQActionBtn.scss';

/** Интерфейс для компонента EQActionBtn */
interface IEQActionBtnProps {
	action: EQActionType;
	onClick: (action: string) => void;
}

/** Общий компонент кнопки действия */
const ActionButton: React.FC<{
	action: EQActionType;
	onClick: (action: string) => void;
	className?: string;
}> = ({ action, onClick, className }) => {
	const Icon = action.icon;
	return (
		<Hint placement="right" messageText={action.title}>
			<button
				className={className || 'eq_btn'}
				onClick={() => {
					return onClick(action.name);
				}}
			>
				{Icon ? <Icon /> : <span>{action.title || action.name}</span>}
			</button>
		</Hint>
	);
};

/** Основной компонент кнопки действия. Определяет тип кнопки на основе наличия поддействий и рендерит соответствующий компонент */
export const EQActionBtn: React.FC<IEQActionBtnProps> = (props) => {
	if (props.action.subAction) {
		return <EQActionBtnExpand {...props} />;
	} else {
		return <EQActionBtnStd {...props} />;
	}
};

/** Компонент стандартной кнопки действия. Отображает простую кнопку без выпадающего меню */
const EQActionBtnStd: React.FC<IEQActionBtnProps> = ({ action, onClick }) => {
	return <ActionButton action={action} onClick={onClick} />;
};

/**
 * Компонент расширенной кнопки действия с выпадающим меню
 * Отображает основную кнопку + кнопку разворачивания + выпадающий список поддействий
 * Управляет состоянием развернутости меню и закрывает его при клике вне компонента
 */
const EQActionBtnExpand: React.FC<IEQActionBtnProps> = ({
	action,
	onClick,
}) => {
	const [expand, setExpand] = useState<boolean>(false);
	const listRef = useOutsideClick<HTMLUListElement>(() => {
		return setExpand(false);
	});

	return (
		<div className={classNames('eq_btn-expand', { active: expand })}>
			<ActionButton action={action} onClick={onClick} />
			<Hint placement="right" messageText="Развернуть">
				<button
					className="eq_btn expand-btn"
					onClick={() => {
						return setExpand(!expand);
					}}
				>
					<ExpandIcon />
				</button>
			</Hint>
			{expand && (
				<ul ref={listRef} className="expand_btn_list">
					{action.subAction?.map((item) => {
						return (
							<EQActionBtnStd
								key={'actionbtn_' + item.name}
								action={item}
								onClick={onClick}
							/>
						);
					})}
				</ul>
			)}
		</div>
	);
};
